import api from '../../../App/socket';

export const getLeadsAllValuations = ref_bike_lead => (
    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Read',
        options: {
            attributes: ['valuations.created_date', 'valuations.description', 'valuations.valuation_by', 'valuations.valuation', 'valuations.retail_price'],
            include: [
                {
                    model: 'Lead_source',
                    path: 'ref_lead_source',
                    attributes: ['abbr', 'name'],
                }, {
                    model: 'User',
                    path: 'valuations.valuation_by',
                    attributes: ['person.first_name', 'person.last_name'],
                }, {
                    model: 'Lead_status',
                    path: 'ref_lead_status',
                    attributes: ['name'],
                },
            ],
            where: { ref_bike_lead },
        },
    })
        .then(response => response)
        .catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/get_leads_valuations_request.js